import { useState } from "react";
import SectionMyAccount from "../sections/SectionMyAccount";
import Sidebar from "./Sidebar";
import { useGetCurrentUser } from "../../hooks/useAuth";
import { st } from "../../constants/styles";
import SectionOrders from "../sections/SectionOrders";
import SectionOrderDetails from "../sections/SectionOrderDetails";
import SectionAddressBook from "../sections/SectionAddressBook";
import SectionAccountManagement from "../sections/SectionAccountManagement";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../Features/Auth/authSlice";
import { clearLocalCart } from "../../Features/Cart/cartSlice";
import Prescriptions from "../sections/Prescriptions";

const SECTION_MAP = {
  account: SectionMyAccount,
  orders: SectionOrders,
  prescriptions: Prescriptions,
  orderdetails: SectionOrderDetails,
  addresses: SectionAddressBook,
  management: SectionAccountManagement,
};

function ProfileMain() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [active, setActive] = useState("account");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  // const { data = {}, isPending, isError } = useGetCurrentUser();

  // let { user } = data ?? {};

  const {
    user: authUser,
    isLoading,
    isError,
  } = useSelector((state) => state.auth);
  let { user } = authUser ?? {};

  const ActiveSection = SECTION_MAP[active];

  const handleLogOut = async () => {
    dispatch(logoutUser());
    navigate("/auth/login", {
      replace: true,
    });
    dispatch(clearLocalCart());
    localStorage.clear();
    // clear persisted storage (localStorage/sessionStorage)
    // await persistor.purge();
    window.location.reload();
  };

  return (
    <section className="py-60">
      <div className="container container-lg">
        <div className="row g-4">
          <div className="col-lg-3">
            <Sidebar
              active={active}
              setActive={setActive}
              user={user}
              onSignOut={() => handleLogOut()}
              loading={isLoading}
            />
          </div>
          <div className="col-lg-9">
            <div style={st.card}>
              <ActiveSection
                user={user}
                orderId={selectedOrderId} // pass selected order
                loading={isLoading}
                isError={isError}
                onSelectOrder={(orderId) => {
                  setSelectedOrderId(orderId);
                  setActive("orderdetails");
                }}
                onBack={() => setActive("orders")} // back button
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProfileMain;
